module.exports = __webpack_public_path__ + "img/bg_card_register.b390e9fb.jpg";